import { render } from "./MerchantManageListPage.vue?vue&type=template&id=4d34be03&lang=true"
import script from "./MerchantManageListPage.vue?vue&type=script&lang=js"
export * from "./MerchantManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__